import { useContext, useState } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { AutoFillVerificationSchema } from '@/utils/validationSchemas/address'
import { getDefaultValues } from '@/utils/helpers/address'
import {
  AutoFillVerificationForm,
  UseAutoFillAddressFormProps,
  UseAutoFillAddressFormReturn,
} from '@/types/v2/address' 
import { isDeepEqual } from '@/utils/helpers/objects'
import AppContext from '@/AppContext'  
 
export const useAutoFillAddressForm = ({
  previousValues,
  states, 
  setIsAdding,
  setFormValues, 
  setValueContext
}: UseAutoFillAddressFormProps): UseAutoFillAddressFormReturn => {
  const { setToast, fireToast } = useContext(AppContext)  
  const [prevSubmittedValues, setPrevSubmittedValues] = useState<AutoFillVerificationForm | null>(null) 
  
  const formMethods = useForm({
    mode: 'all',
    defaultValues: getDefaultValues(previousValues),
    resolver: yupResolver(AutoFillVerificationSchema),
  })

  const onSubmit = async (formValues: AutoFillVerificationForm) => {  
    try {
      const isSameRequest = isDeepEqual(formValues, prevSubmittedValues)
      if (!isSameRequest) {
        const zipCode = formValues.zipCode.replace(' ', '')
        const found = states.find(({ id }) => Number(formValues.stateId) === id)

        setFormValues({
          address_apt:formValues.extraInfo||"",
          city: formValues.city,
          street:  formValues.street,
          state_id: found.id,
          zip_code: zipCode,
          county: formValues.county,
          latitude: 0,
          state_selected: null,
          longitude: 0, 
        })  
        setValueContext('is_verified',formValues.is_verified||false)
        setIsAdding(false) 
        setPrevSubmittedValues(formValues)  
      }
    } catch (errorInPromise) { 
      setToast('error', 'An error has ocurred during the validation')
      fireToast()
    }
  } 

  return {
    formMethods, 
    onSubmit 
  }
}
